import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, computed, getCurrentInstance, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'expandable-content',
  props: {
    expandedByDefault: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { expandedByDefault: boolean };

const instance = getCurrentInstance();
const vm = instance?.proxy as Vue;

const IconArrow = defineAsyncComponent(() => import("@white-label-icon/icon-arrow"));

const expandableIsActive = ref(false);

const toggleExpandable = () => {
  expandableIsActive.value = !expandableIsActive.value;
};

const setExpanded = (value: boolean) => {
  expandableIsActive.value = value;
};



onMounted(() => {
  if (props.expandedByDefault) {
    expandableIsActive.value = true;
  }
});

const expandableContentAriaLabel = computed(() => {
  return expandableIsActive.value
    ? vm.$t('searchParkingMoreInfoModal.hideExpandableContent').toString()
    : vm.$t('searchParkingMoreInfoModal.showExpandableContent').toString();
});

expose({
  setExpanded,
});

return { __sfc: true,instance, vm, IconArrow, expandableIsActive, toggleExpandable, setExpanded, props, expandableContentAriaLabel }
}

})